import * as cart from '@shopify/theme-cart';
import * as cartHandler from './components/cartHandling';
import * as imageSlider from './components/imageSlider';
import * as cookieHandler from "./components/cookies";

window.cart = cart;
window.cartHandler = cartHandler;
window.imageSlider = imageSlider;

if (!cookieHandler.getCookie('newsletterPopup')){
    setTimeout(function () {
        Fancybox.show([
            {
                src: "#newsletter-popup",
                type: "inline",
            }
        ]);
    }, 6000);

    cookieHandler.setCookie('newsletterPopup', 'true', 20);
}

